/**
 * Build using the jQuery UI Dialog:
 * - http://jqueryui.com/dialog/
 *
 * @author scarlson <scott.carlson@synegen.com>
 */
;(function($) {
    // Ensure webpack bundles jqueryui functionality for easydialog to work
    require('jqueryui');

    /*
     * Constants
     */

    var FADE_MS = 350,
        TOP_POSITION = '160px',

    /*
     * Working values (globals)
     */

        dialogs = [],
        scrollTopBody = 0,
        scrollTopHtml = 0,
        selectedArray = [],
        selectedIndex = 0,

    /*
     * Private methods
     */

        _closeAndDestroy = function(containerId) {
            var $dialog = _getDialog(containerId);

            if ($dialog) {
                $dialog.dialog('close');
                $dialog.dialog('destroy');

                if ($dialog.destroyContentOnClose) {
                    $dialog.html('');
                }

                dialogs[containerId] = null;
            }
        },

        _getDialog = function(containerId) {
            return dialogs[containerId];
        },

        _prepareStart = function($dialog, obj) {
            var opts = typeof arguments[1] !== 'undefined' ? arguments[1] : {};

            selectedArray = [];
            selectedIndex = parseInt(opts.index, 10) || 0;

            if (typeof obj == 'object') {
                $(obj).data('easydialog', $.extend({}, opts, obj));
            } else {
                obj = $({}).data('easydialog', $.extend({content : obj}, opts));
            }

            selectedArray.push(obj);

            if (selectedIndex > selectedArray.length || selectedIndex < 0) {
                selectedIndex = 0;
            }

            var selectedOpts = $.extend({}, $.fn.easydialog.defaults, obj);

            if (selectedOpts.content) {
                $dialog.html(obj.content);
            }

            _start();
        },

        _registerDialog = function($dialog, containerId, destroyContentOnClose) {
            $dialog.destroyContentOnClose = destroyContentOnClose;
            dialogs[containerId] = $dialog;
        },

        _resetScroll = function() {
            scrollTopBody = 0,
            scrollTopHtml = 0;
        },

        _start = function() {
            var obj = selectedArray[ selectedIndex ];

            scrollTopHtml = $('html').scrollTop();
            scrollTopBody = $('body').scrollTop();

            $('html, body').animate({scrollTop: 0}, FADE_MS);

            var selectedOpts = $.extend({}, $.fn.easydialog.defaults, (typeof $(obj).data('easydialog') == 'undefined' ? {} : $(obj).data('easydialog'))),
                $dialog = _getDialog(selectedOpts.container);

            $dialog.addClass('invisible');

            $dialog.dialog({
                beforeClose: function(event) {
                    selectedOpts.beforeClose(event);
                    selectedOpts.onCleanup();
                },
                close: function() {
                    if (!selectedOpts.preventScrollOnClose) {
                        $('html').animate({scrollTop: scrollTopHtml}, FADE_MS);
                        $('body').animate({scrollTop: scrollTopBody}, FADE_MS);
                    }

                    selectedOpts.onClosed();
                },
                closeOnEscape: selectedOpts.closeOnEscape,
                create: function(event) {
                    // create and onStart are not equal - make sure this works
                    selectedOpts.onStart(event);
                },
                dialogClass: selectedOpts.dialogClass,
                draggable: false,
                hide: 0, // FADE_MS,    // Despite what docs say, this does not cause a fade, but merely a delay before closing.
                modal: true,
                open: function() {
                    _.defer(function() {
                        selectedOpts.onComplete();
                        $dialog.hide();
                        $dialog.removeClass('invisible');
                        $dialog.fadeIn(FADE_MS);
                    });

                    $dialog.dialog('widget').css('top', TOP_POSITION);

                    if (!selectedOpts.showCloseButton) {
                        $dialog.dialog('widget').find('.ui-dialog-titlebar-close').hide();
                    }
                },
                position: {my: 'center', at: 'top', of: window},
                resizable: false,
                show: 0,
                width: 'auto'
            });

            $dialog.dialog('widget').addClass('closeColor-' + selectedOpts.closeColor);
        };

    /*
     * Public methods
     */

    /*
     * On-click creation of dialogs - bound to given objects.
     */
    $.fn.easydialog = function(rawOptions) {
        var $this = $(this),
            thisOptions = rawOptions;

        if (!$this.length) {
            return this;
        }

        $this.unbind('click.fb').bind('click.fb', function(event) {
            event.preventDefault();

            var $dialog = $($this.attr('href')),
                selectedOpts = $.extend({}, $.fn.easydialog.defaults, thisOptions);

            if (!$dialog[0].easyDialogWrapped) {
                $dialog[0].easyDialogWrapped = true;
                $dialog.wrap('<div></div>');
            }

            $dialog = $dialog.parent();

            _resetScroll();
            _closeAndDestroy(selectedOpts.container);
            _registerDialog($dialog, selectedOpts.container, false);

            _prepareStart($dialog, thisOptions);
        });

        return this;
    };

    /*
     * On-demand creation of dialog.
     */
    $.easydialog = function(rawOptions) {
        var selectedOpts = $.extend({}, $.fn.easydialog.defaults, rawOptions),
            $dialog = $('<div></div>');

        _resetScroll();
        _closeAndDestroy(selectedOpts.container);
        _registerDialog($dialog, selectedOpts.container, true);

        _prepareStart($dialog, rawOptions);
        
        return $dialog;
    };

    $.easydialog.close = function(containerId) {
        var $dialog = _getDialog(containerId);

        if ($dialog) {
            _closeAndDestroy(containerId);
        }
    };

    $.fn.easydialog.defaults = {
        // properties

        closeColor: 'white',             // color of 'X' button in dialog - valid values are: 'white', 'grey'
        closeOnEscape: true,
        container: 'default',
        dialogClass: '',
        showCloseButton: true,

        // callbacks

        beforeClose: $.noop,
        onStart: $.noop,
        onComplete: $.noop,
        onCleanup: $.noop,
        onClosed: $.noop
    };
})(jQuery);



//////////////////
// WEBPACK FOOTER
// ./js/libs/custom/jquery/jquery.easyDialog.js
// module id = 8
// module chunks = 25 26